import { render } from "./partner-view.vue?vue&type=template&id=e7511f06&ts=true"
import script from "./partner-view.vue?vue&type=script&lang=ts"
export * from "./partner-view.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__